export class AdminCampaignController {
  constructor($scope, CampaignService, CampaignTemplateService, RegionService, CityService) {
    $scope.vm = this;
    $scope.allCampaigns = [];
    $scope.allTemplates = [];
    $scope.campaignFormModel = {};
    $scope.allCampaignsSelected = { state: false };
    $scope.campaignSelected = {};
    $scope.regions = [];
    $scope.cities = [];
    $scope.allCities = [];
    $scope.vars = {};

    $scope.show = {
      create: false,
      read: false,
      update: false
    };

    $scope.ages = [
      {id: '1', value: "From 18 to 24"},
      {id: '2', value: "From 25 to 31"},
      {id: '3', value: "From 32 to 38"},
      {id: '4', value: "From 39 to 45"},
      {id: '5', value: "From 46 to 52"},
      {id: '6', value: "From 53 to 100"}
    ];

    $scope.page = 1;
    $scope.limit = 12;
    $scope.total = 0;

    this.scope = $scope;
    this.CampaignService = CampaignService;
    this.CampaignTemplateService = CampaignTemplateService;
    this.RegionService = RegionService;
    this.CityService = CityService;
    this.init();
  }

  init() {
    this.getCampaigns = () => {
      this.CampaignService.getCampaigns()
        .then((response) => { let data = response.data;
          console.log(data.data);
          this.scope.allCampaigns = data.data;
          this.scope.campaignSelected = {};

          _.forEach(this.scope.allCampaigns, (campaign) => {
            this.scope.campaignSelected[campaign._id] = false;
          });

          this.scope.allCampaignsSelected.state = false;
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        })
    };

    this.scope.getFullFilterAge = (age) => {
      switch(age) {
        case '1':
          return {minage: 18, maxage: 24}
        case '2':
          return {minage: 25, maxage: 31}
        case '3':
          return {minage: 32, maxage: 38}
        case '4':
          return {minage: 39, maxage: 45}
        case '5':
          return {minage: 46, maxage: 52}
        case '6':
          return {minage: 53, maxage: 100}
        default:
          return {minage: 18, maxage: 100}
      }
    }

    this.scope.getFilterAge = (age) => {
      if(age.minage == 18 && age.maxage == 24)
        return '1';
      else if(age.minage == 25 && age.maxage == 31)
        return '2';
      else if(age.minage == 32 && age.maxage == 38)
        return '3';
      else if(age.minage == 39 && age.maxage == 45)
        return '4';
      else if(age.minage == 46 && age.maxage == 52)
        return '5';
      else if(age.minage == 53 && age.maxage == 100)
        return '6';
      else
        return '0';
    }

    this.RegionService.getRegionsList()
      .then((response) => { let regions = response.data;
        this.scope.regions = regions.data;
      })
      .catch((response) => { let error = response.data;
        console.log("Can`t get regions from database");
      });

    this.CityService.getCitiesList()
      .then((response) => { let cities = response.data;
        this.scope.allCities = cities.data;
      })
      .catch((response) => { let error = response.data;
        console.log("Can`t get cities from database");
      });

    this.scope.changeRegion = () => {
      this.scope.cities = [];
      this.scope.campaignFormModel.filters.city = null;
      var region = this.scope.campaignFormModel.filters.region;

      _(this.scope.allCities).forEach((city) => {
        if(city.region == region) {
          this.scope.cities.push(city);
        }
      }).value();
    }

    this.scope.changeTemplate = () => {
      this.CampaignTemplateService.getCampaignTemplate(this.scope.campaignFormModel.template)
        .then((response) => { let template = response.data;
          this.scope.parseTemplateVars(template.data);
        })
        .catch((response) => { let error = response.data;
          console.log(error);
        })
      }

    this.scope.parseTemplateVars = (template) => {
      let currentVars = template.content.match(/\*\|.*?\|\*/g);
      let result = [];

      _.forEach(currentVars, (nVar) => {
        let obj = {};
        obj[nVar] = "";
        result.push(obj);
      });

      this.scope.campaignFormModel.vars = result;
    }

    this.CampaignTemplateService.getCampaignTemplateNames()
      .then((response) => { let templates = response.data;
        this.scope.allTemplates = templates.data;
      })
      .catch((response) => { let error = response.data;
        console.log(error);
      })

    this.scope.selectAllCampaigns = () => {
      var check = this.scope.allCampaignsSelected.state;

      _.forEach(this.scope.campaignSelected, (campaign, key) => {
        this.scope.campaignSelected[key] = !!check;
      })
    };

    this.scope.changeCrudView = (view) => {
      this.scope.show.create = false;
      this.scope.show.read = false;
      this.scope.show.update = false;

      if(view == 'create') {
        this.scope.campaignFormModel = {};
        this.scope.campaignFormModel.quantity = 0;
        this.scope.campaignFormModel.vars = {};
        this.scope.campaignFormModel.template_content = [];
        this.scope.campaignFormModel.filters = {};
        this.scope.campaignFormModel.filters.age = this.scope.getFilterAge({});
      }

      this.scope.show[view] = true;
    };

    this.scope.changeCrudView('read');
    this.getCampaigns();

    this.scope.createCampaign = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if(this.scope.errors.length) {
        return false;
      }

      var age = this.scope.getFullFilterAge(this.scope.campaignFormModel.filters.age);
      this.scope.campaignFormModel.filters.minage = age.minage;
      this.scope.campaignFormModel.filters.maxage = age.maxage;

      console.log(this.scope.campaignFormModel);

      //delete this.scope.campaignFormModel.filters.age;

      this.CampaignService.createCampaign(this.scope.campaignFormModel)
        .then((response) => { let data = response.data;
          this.scope.changeCrudView('read');
          this.getCampaigns();
        }).catch((response) => { let e = response.data;
          console.log(e);
        });
    };

    /*this.scope.updateCampaign = (emailCampaign) => {
      this.scope.campaignFormModel = angular.copy(emailCampaign);
      this.scope.changeCrudView('update');
    };*/

    this.scope.updateCampaignBtn = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      });

      if(this.scope.errors.length) {
        return false;
      }

      var age = this.scope.getFullFilterAge(this.scope.campaignFormModel.filters.age);
      this.scope.campaignFormModel.filters.minage = age.minage;
      this.scope.campaignFormModel.filters.maxage = age.maxage;

      if(!this.scope.campaignFormModel.filters.region) {
        this.scope.campaignFormModel.filters.region = null;
      }

      if(!this.scope.campaignFormModel.filters.city) {
        this.scope.campaignFormModel.filters.city = null;
      }

      if (this.scope.vars) {
        let tempVars = [];
        _.forEach(this.scope.vars, (val, key) => {
          if (key[0] === '*') {
            let obj = {};
            obj[key] = val;
            tempVars.push(obj);
          };
        });

        this.scope.campaignFormModel.vars = tempVars;
      }

      this.CampaignService.updateCampaign(this.scope.campaignFormModel)
        .then((response) => { let data = response.data;
          console.log(data);
          this.scope.changeCrudView('read');
          this.getCampaigns();
        }).catch((response) => { let e = response.data;
          console.log(e);
        });
    };

    this.scope.editCampaign = (campaign) => {
      this.scope.campaignFormModel = angular.copy(campaign);

      this.scope.campaignFormModel.template = this.scope.campaignFormModel.template._id;
      this.scope.campaignFormModel.scheduled = new Date(this.scope.campaignFormModel.scheduled);

      if(this.scope.campaignFormModel.filters.region) {
        this.scope.campaignFormModel.filters.region = this.scope.campaignFormModel.filters.region._id;
      }

      if(this.scope.campaignFormModel.filters.city) {
        this.scope.campaignFormModel.filters.city = this.scope.campaignFormModel.filters.city._id;
      }

      if(!this.scope.campaignFormModel.filters.gender) {
        this.scope.campaignFormModel.filters.gender = null;
      } else {
        this.scope.campaignFormModel.filters.gender = this.scope.campaignFormModel.filters.gender + '';
      }

      this.scope.campaignFormModel.filters.age = this.scope.getFilterAge(
        {
          minage: this.scope.campaignFormModel.filters.minage,
          maxage: this.scope.campaignFormModel.filters.maxage
        }
      );


      if (this.scope.campaignFormModel.vars) {
        let tempVars = {};

        _.forEach(this.scope.campaignFormModel.vars, (varVal) => {
          _.forEach(varVal, (val, key) =>{
            if (key[0] === '*'){
              tempVars[key] = val;
            }
          })
        });

        this.scope.vars = tempVars;
      }




      var city = this.scope.campaignFormModel.filters.city;
      this.scope.changeRegion();
      this.scope.campaignFormModel.filters.city = city;

      this.scope.changeCrudView('update');
    }

    this.scope.removeCampaigns = () => {
      var countdown = 0;
      _.forEach(this.scope.campaignSelected, (val, key) => {
        if (val) {
          countdown++;
          this.CampaignService.removeCampaign(key)
            .then((response) => { let data = response.data;
              countdown--;
              if (countdown == 0) {
                this.getCampaigns();
              }
            }).catch((response) => { let e = response.data;
              countdown--;
              if (countdown == 0) {
                this.scope.refreshPage();
              }
              console.log(e);
            });
        }
      })
    };
  }
}
